import React, { useState } from "react";
import "./Cheaper.css";
import { Link } from "react-router-dom";

// Function to get tomorrow's date in YYYY-MM-DD format
const getTomorrowDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().split("T")[0];
};

// All 16 flight deals (8 domestic + 8 international)
const dealss = [
  // ✅ Domestic Deals (8)
  {
    origin: "SFO",
    destination: "YVR",
    route: "San Francisco → Vancouver",
    img: "//c.fareportal.com/gcms/portals/2/images/destinations/YVR-r2x.jpg",
    price: "58.99",
    type: "one-way",
  },
  {
    origin: "LAX",
    destination: "YVR",
    route: "Los Angeles → Vancouver",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-1-r2x.jpg",
    price: "74.99",
    type: "one-way",
  },
  {
    origin: "ATL",
    destination: "YYC",
    route: "Atlanta ⇌ Calgary",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-2-r2x.jpg",
    price: "204.99",
    type: "round-trip",
  },
  {
    origin: "ORD",
    destination: "YTO",
    route: "Chicago → Toronto",
    img: "//c.fareportal.com/gcms/portals/2/images/destinations/YTO-r2x.jpg",
    price: "83.90",
    type: "one-way",
  },
  {
    origin: "LAX",
    destination: "YTO",
    route: "Los Angeles → Toronto",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-3-r2x.jpg",
    price: "96.65",
    type: "one-way",
  },
  {
    origin: "SFO",
    destination: "YVR",
    route: "San Francisco ⇌ Vancouver",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-0-r2x.jpg",
    price: "122.99",
    type: "round-trip",
  },
  {
    origin: "LAX",
    destination: "YYC",
    route: "Los Angeles → Calgary",
    img: "//c.fareportal.com/gcms/portals/2/images/destinations/YYC-r2x.jpg",
    price: "104.99",
    type: "one-way",
  },
  {
    origin: "ORD",
    destination: "YTO",
    route: "Chicago ⇌ Toronto",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-1-r2x.jpg",
    price: "175.91",
    type: "round-trip",
  },

  // ✅ International Deals (8)
  {
    origin: "SFO",
    destination: "LHR",
    route: "San Francisco ⇌ London",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-4-r2x.jpg",
    price: "599.99",
    type: "round-trip",
  },
  {
    origin: "LAX",
    destination: "CDG",
    route: "Los Angeles ⇌ Paris",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-5-r2x.jpg",
    price: "645.50",
    type: "round-trip",
  },
  {
    origin: "JFK",
    destination: "DXB",
    route: "New York ⇌ Dubai",
    img: "https://res.cloudinary.com/dtljonz0f/image/upload/c_auto,ar_4:3,w_3840,g_auto/f_auto/q_auto/v1/gc-v1/new-york/shutterstock_2142178205_yxfbc3?_a=BAVAZGE70",
    price: "834.75",
    type: "round-trip",
  },
  {
    origin: "ORD",
    destination: "NRT",
    route: "Chicago ⇌ Tokyo",
    img: "https://www.shutterstock.com/image-photo/chicago-il-usa-september-27th-600nw-2505875281.jpg",
    price: "918.20",
    type: "round-trip",
  },
  {
    origin: "DFW",
    destination: "GRU",
    route: "Dallas ⇌ São Paulo",
    img: "https://i.insider.com/676455146c531c315b895507?width=700",    price: "780.30",
    type: "round-trip",
  },
  {
    origin: "ATL",
    destination: "JNB",
    route: "Atlanta ⇌ Johannesburg",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-9-r2x.jpg",
    price: "1024.99",
    type: "round-trip",
  },
  {
    origin: "MIA",
    destination: "MAD",
    route: "Miami ⇌ Madrid",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-10-r2x.jpg",
    price: "550.00",
    type: "round-trip",
  },
  {
    origin: "SEA",
    destination: "SYD",
    route: "Seattle ⇌ Sydney",
    img: "//c.fareportal.com/gcms/portals/2/Images/destinations/Generic-11-r2x.jpg",
    price: "1049.49",
    type: "round-trip",
  },
];

const Cheaper = () => {
  const [activeTab, setActiveTab] = useState("all");
  const tomorrowDate = getTomorrowDate();

  const getOneWayUrl = (dest, org) => {
    return `/flightList/dest_${dest}*org_${org}*dep_${tomorrowDate}*arr_${tomorrowDate}*px_1-0-0*jt_1*cbn_2`;
  };

  const getRoundTripUrl = (dest, org) => {
    return `/round/dest_${dest}*org_${org}*dep_${tomorrowDate}*arr_${tomorrowDate}*px_1-0-0*jt_2*cbn_2`;
  };

  // Filter deals based on tab
  let displayedDeals;
  if (activeTab === "one-way") {
    displayedDeals = dealss.filter((deal) => deal.type === "one-way").slice(0, 8);
  } else if (activeTab === "round-trip") {
    displayedDeals = dealss.filter((deal) => deal.type === "round-trip").slice(0, 8);
  } else {
    // all tab - show first 8 deals total (mix of types) or you can do 8 one-way + 8 round-trip (total 16)
    // Here, showing 16 deals (8 one-way + 8 round-trip)
    const oneWay = dealss.filter((deal) => deal.type === "one-way").slice(0, 8);
    const roundTrip = dealss.filter((deal) => deal.type === "round-trip").slice(0, 8);
    displayedDeals = [...oneWay, ...roundTrip];
  }

  return (
    <div>
      <section className="theme-bg-white py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="h3 text-center fw-bold theme-text-secondary mb-4">
                Flight World Offers, Coupons and Daily Deals
              </h2>
            </div>

            {/* Tabs */}
            <div className="col-12">
              <div className="d-flex justify-content-center">
                <ul
                  className="nav nav-pills mb-3 deals-tab"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "all" ? "active" : ""}`}
                      onClick={() => setActiveTab("all")}
                    >
                      All
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "one-way" ? "active" : ""}`}
                      onClick={() => setActiveTab("one-way")}
                    >
                      One Way
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "round-trip" ? "active" : ""}`}
                      onClick={() => setActiveTab("round-trip")}
                    >
                      Round Trip
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            {/* Flight Cards */}
            <div className="col-12 mt-5">
              <div className="tab-content offers-content">
                <div className="tab-pane fade show active" role="tabpanel">
                  <div className="row">
                    {displayedDeals.slice(0,8).map((item, index) => (
                      <div key={index} className="col-12 col-md-6 col-lg-3 mb-3">
                        <div className="d-flex flex-column theme-box-shadow theme-border-radius">
                          <div className="wrap-img theme-border-radius-top img-effect">
                            {/* <img
                              src={item.img}
                              className="img-fluid"
                              alt={item.route}
                              style={{width:"320px",height:"165px",objectFit:'cover'}}
                            /> */}
                          </div>
                          <div className="d-flex flex-column p-3">
                            <span
                              style={{
                                fontWeight: "700",
                                color: "#212529",
                                fontSize: "16px",
                              }}
                            >
                              {item.route}
                            </span>
                            <span
                              className="font-medium theme-text-accent-one"
                              style={{ fontWeight: "600", color: "#343534", fontSize: "14px" }}
                            >
                          {item.type === "one-way" && "One way"}
                                {item.type === "round-trip" && "Round Trip"} | {tomorrowDate}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between p-3">
                            <span className="font-medium theme-text-accent-two" style={{fontWeight:"700",color:'#053355'}}>
                              ${item.price}
                            </span>
                            <Link
                              to={
                                item.type === "one-way"
                                  ? getOneWayUrl(item.destination, item.origin)
                                  : getRoundTripUrl(item.destination, item.origin)
                              }
                              className="font-medium"
                            >
                              Book Now
                            </Link>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Cheaper;
